/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetPlanAssignmentIdExecutionSummaryParams,
  GetPlanAssignmentIdFullParams,
  GetPlanAssignmentIdOverviewParams,
  GetPlanAssignmentMineParams,
  PostPlanAssignmentIdAddWeekParams,
  PostPlanAssignmentIdCompleteParams,
  PostPlanAssignmentIdEndEarlyParams,
  PostPlanAssignmentIdPauseParams,
  PostPlanAssignmentIdResumeParams,
  PostPlanAssignmentParams,
  TrainWithMeModulesTrainingDtosRequestsPostPlanAssignmentRequest,
  TrainWithMeModulesTrainingDtosRequestsShiftRemainingRequest,
  TrainWithMeModulesTrainingDtosResponsesExecutionSummaryResponse,
  TrainWithMeModulesTrainingDtosResponsesPlanAssignmentFullResponse,
  TrainWithMeModulesTrainingDtosResponsesPlanAssignmentSummary,
  TrainWithMeModulesTrainingDtosResponsesPlanOverviewResponse,
  TrainWithMeModulesTrainingDtosResponsesShiftRemainingResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getPlanAssignment = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesPlanAssignmentSummary[]>(
      {url: `/plan-assignment`, method: 'GET', signal
    },
      options);
    }




export const getGetPlanAssignmentQueryKey = () => {
    return [
    `/plan-assignment`
    ] as const;
    }


export const getGetPlanAssignmentQueryOptions = <TData = Awaited<ReturnType<typeof getPlanAssignment>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanAssignmentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanAssignment>>> = ({ signal }) => getPlanAssignment(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlanAssignmentQueryResult = NonNullable<Awaited<ReturnType<typeof getPlanAssignment>>>
export type GetPlanAssignmentQueryError = ErrorType<unknown>


export function useGetPlanAssignment<TData = Awaited<ReturnType<typeof getPlanAssignment>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanAssignment>>,
          TError,
          Awaited<ReturnType<typeof getPlanAssignment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanAssignment<TData = Awaited<ReturnType<typeof getPlanAssignment>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanAssignment>>,
          TError,
          Awaited<ReturnType<typeof getPlanAssignment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanAssignment<TData = Awaited<ReturnType<typeof getPlanAssignment>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPlanAssignment<TData = Awaited<ReturnType<typeof getPlanAssignment>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlanAssignmentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postPlanAssignment = (
    trainWithMeModulesTrainingDtosRequestsPostPlanAssignmentRequest?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostPlanAssignmentRequest>,
    params?: PostPlanAssignmentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesPlanAssignmentFullResponse>(
      {url: `/plan-assignment`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesTrainingDtosRequestsPostPlanAssignmentRequest,
        params, signal
    },
      options);
    }




export const getPostPlanAssignmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignment>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostPlanAssignmentRequest>;params?: PostPlanAssignmentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignment>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostPlanAssignmentRequest>;params?: PostPlanAssignmentParams}, TContext> => {

const mutationKey = ['postPlanAssignment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPlanAssignment>>, {data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostPlanAssignmentRequest>;params?: PostPlanAssignmentParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postPlanAssignment(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPlanAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof postPlanAssignment>>>
    export type PostPlanAssignmentMutationBody = BodyType<TrainWithMeModulesTrainingDtosRequestsPostPlanAssignmentRequest> | undefined
    export type PostPlanAssignmentMutationError = ErrorType<unknown>

    export const usePostPlanAssignment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignment>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostPlanAssignmentRequest>;params?: PostPlanAssignmentParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPlanAssignment>>,
        TError,
        {data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostPlanAssignmentRequest>;params?: PostPlanAssignmentParams},
        TContext
      > => {
      return useMutation(getPostPlanAssignmentMutationOptions(options), queryClient);
    }
    export const getPlanAssignmentCustomerCustomerId = (
    customerId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesPlanAssignmentSummary[]>(
      {url: `/plan-assignment/customer/${customerId}`, method: 'GET', signal
    },
      options);
    }




export const getGetPlanAssignmentCustomerCustomerIdQueryKey = (customerId: number,) => {
    return [
    `/plan-assignment/customer/${customerId}`
    ] as const;
    }


export const getGetPlanAssignmentCustomerCustomerIdQueryOptions = <TData = Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>, TError = ErrorType<unknown>>(customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanAssignmentCustomerCustomerIdQueryKey(customerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>> = ({ signal }) => getPlanAssignmentCustomerCustomerId(customerId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlanAssignmentCustomerCustomerIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>>
export type GetPlanAssignmentCustomerCustomerIdQueryError = ErrorType<unknown>


export function useGetPlanAssignmentCustomerCustomerId<TData = Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>, TError = ErrorType<unknown>>(
 customerId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanAssignmentCustomerCustomerId<TData = Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>, TError = ErrorType<unknown>>(
 customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanAssignmentCustomerCustomerId<TData = Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>, TError = ErrorType<unknown>>(
 customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPlanAssignmentCustomerCustomerId<TData = Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>, TError = ErrorType<unknown>>(
 customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentCustomerCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlanAssignmentCustomerCustomerIdQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlanAssignmentMine = (
    params?: GetPlanAssignmentMineParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesPlanAssignmentFullResponse>(
      {url: `/plan-assignment/mine`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPlanAssignmentMineQueryKey = (params?: GetPlanAssignmentMineParams,) => {
    return [
    `/plan-assignment/mine`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPlanAssignmentMineQueryOptions = <TData = Awaited<ReturnType<typeof getPlanAssignmentMine>>, TError = ErrorType<unknown>>(params?: GetPlanAssignmentMineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentMine>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanAssignmentMineQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanAssignmentMine>>> = ({ signal }) => getPlanAssignmentMine(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentMine>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlanAssignmentMineQueryResult = NonNullable<Awaited<ReturnType<typeof getPlanAssignmentMine>>>
export type GetPlanAssignmentMineQueryError = ErrorType<unknown>


export function useGetPlanAssignmentMine<TData = Awaited<ReturnType<typeof getPlanAssignmentMine>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPlanAssignmentMineParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentMine>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanAssignmentMine>>,
          TError,
          Awaited<ReturnType<typeof getPlanAssignmentMine>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanAssignmentMine<TData = Awaited<ReturnType<typeof getPlanAssignmentMine>>, TError = ErrorType<unknown>>(
 params?: GetPlanAssignmentMineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentMine>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanAssignmentMine>>,
          TError,
          Awaited<ReturnType<typeof getPlanAssignmentMine>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanAssignmentMine<TData = Awaited<ReturnType<typeof getPlanAssignmentMine>>, TError = ErrorType<unknown>>(
 params?: GetPlanAssignmentMineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentMine>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPlanAssignmentMine<TData = Awaited<ReturnType<typeof getPlanAssignmentMine>>, TError = ErrorType<unknown>>(
 params?: GetPlanAssignmentMineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentMine>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlanAssignmentMineQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postPlanAssignmentIdAddWeek = (
    id: number,
    params?: PostPlanAssignmentIdAddWeekParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesPlanAssignmentFullResponse>(
      {url: `/plan-assignment/${id}/add-week`, method: 'POST',
        params, signal
    },
      options);
    }




export const getPostPlanAssignmentIdAddWeekMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdAddWeek>>, TError,{id: number;params?: PostPlanAssignmentIdAddWeekParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdAddWeek>>, TError,{id: number;params?: PostPlanAssignmentIdAddWeekParams}, TContext> => {

const mutationKey = ['postPlanAssignmentIdAddWeek'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPlanAssignmentIdAddWeek>>, {id: number;params?: PostPlanAssignmentIdAddWeekParams}> = (props) => {
          const {id,params} = props ?? {};

          return  postPlanAssignmentIdAddWeek(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPlanAssignmentIdAddWeekMutationResult = NonNullable<Awaited<ReturnType<typeof postPlanAssignmentIdAddWeek>>>

    export type PostPlanAssignmentIdAddWeekMutationError = ErrorType<unknown>

    export const usePostPlanAssignmentIdAddWeek = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdAddWeek>>, TError,{id: number;params?: PostPlanAssignmentIdAddWeekParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPlanAssignmentIdAddWeek>>,
        TError,
        {id: number;params?: PostPlanAssignmentIdAddWeekParams},
        TContext
      > => {
      return useMutation(getPostPlanAssignmentIdAddWeekMutationOptions(options), queryClient);
    }
    export const postPlanAssignmentIdComplete = (
    id: number,
    params?: PostPlanAssignmentIdCompleteParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesPlanAssignmentFullResponse>(
      {url: `/plan-assignment/${id}/complete`, method: 'POST',
        params, signal
    },
      options);
    }




export const getPostPlanAssignmentIdCompleteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdComplete>>, TError,{id: number;params?: PostPlanAssignmentIdCompleteParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdComplete>>, TError,{id: number;params?: PostPlanAssignmentIdCompleteParams}, TContext> => {

const mutationKey = ['postPlanAssignmentIdComplete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPlanAssignmentIdComplete>>, {id: number;params?: PostPlanAssignmentIdCompleteParams}> = (props) => {
          const {id,params} = props ?? {};

          return  postPlanAssignmentIdComplete(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPlanAssignmentIdCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof postPlanAssignmentIdComplete>>>

    export type PostPlanAssignmentIdCompleteMutationError = ErrorType<unknown>

    export const usePostPlanAssignmentIdComplete = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdComplete>>, TError,{id: number;params?: PostPlanAssignmentIdCompleteParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPlanAssignmentIdComplete>>,
        TError,
        {id: number;params?: PostPlanAssignmentIdCompleteParams},
        TContext
      > => {
      return useMutation(getPostPlanAssignmentIdCompleteMutationOptions(options), queryClient);
    }
    export const postPlanAssignmentIdEndEarly = (
    id: number,
    params?: PostPlanAssignmentIdEndEarlyParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesPlanAssignmentFullResponse>(
      {url: `/plan-assignment/${id}/end-early`, method: 'POST',
        params, signal
    },
      options);
    }




export const getPostPlanAssignmentIdEndEarlyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdEndEarly>>, TError,{id: number;params?: PostPlanAssignmentIdEndEarlyParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdEndEarly>>, TError,{id: number;params?: PostPlanAssignmentIdEndEarlyParams}, TContext> => {

const mutationKey = ['postPlanAssignmentIdEndEarly'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPlanAssignmentIdEndEarly>>, {id: number;params?: PostPlanAssignmentIdEndEarlyParams}> = (props) => {
          const {id,params} = props ?? {};

          return  postPlanAssignmentIdEndEarly(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPlanAssignmentIdEndEarlyMutationResult = NonNullable<Awaited<ReturnType<typeof postPlanAssignmentIdEndEarly>>>

    export type PostPlanAssignmentIdEndEarlyMutationError = ErrorType<unknown>

    export const usePostPlanAssignmentIdEndEarly = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdEndEarly>>, TError,{id: number;params?: PostPlanAssignmentIdEndEarlyParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPlanAssignmentIdEndEarly>>,
        TError,
        {id: number;params?: PostPlanAssignmentIdEndEarlyParams},
        TContext
      > => {
      return useMutation(getPostPlanAssignmentIdEndEarlyMutationOptions(options), queryClient);
    }
    export const getPlanAssignmentIdExecutionSummary = (
    id: number,
    params?: GetPlanAssignmentIdExecutionSummaryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesExecutionSummaryResponse>(
      {url: `/plan-assignment/${id}/execution-summary`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPlanAssignmentIdExecutionSummaryQueryKey = (id: number,
    params?: GetPlanAssignmentIdExecutionSummaryParams,) => {
    return [
    `/plan-assignment/${id}/execution-summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPlanAssignmentIdExecutionSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>, TError = ErrorType<unknown>>(id: number,
    params?: GetPlanAssignmentIdExecutionSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanAssignmentIdExecutionSummaryQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>> = ({ signal }) => getPlanAssignmentIdExecutionSummary(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlanAssignmentIdExecutionSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>>
export type GetPlanAssignmentIdExecutionSummaryQueryError = ErrorType<unknown>


export function useGetPlanAssignmentIdExecutionSummary<TData = Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetPlanAssignmentIdExecutionSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>,
          TError,
          Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanAssignmentIdExecutionSummary<TData = Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetPlanAssignmentIdExecutionSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>,
          TError,
          Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanAssignmentIdExecutionSummary<TData = Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetPlanAssignmentIdExecutionSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPlanAssignmentIdExecutionSummary<TData = Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetPlanAssignmentIdExecutionSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdExecutionSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlanAssignmentIdExecutionSummaryQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlanAssignmentIdFull = (
    id: number,
    params?: GetPlanAssignmentIdFullParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesPlanAssignmentFullResponse>(
      {url: `/plan-assignment/${id}/full`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPlanAssignmentIdFullQueryKey = (id: number,
    params?: GetPlanAssignmentIdFullParams,) => {
    return [
    `/plan-assignment/${id}/full`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPlanAssignmentIdFullQueryOptions = <TData = Awaited<ReturnType<typeof getPlanAssignmentIdFull>>, TError = ErrorType<unknown>>(id: number,
    params?: GetPlanAssignmentIdFullParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdFull>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanAssignmentIdFullQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanAssignmentIdFull>>> = ({ signal }) => getPlanAssignmentIdFull(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdFull>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlanAssignmentIdFullQueryResult = NonNullable<Awaited<ReturnType<typeof getPlanAssignmentIdFull>>>
export type GetPlanAssignmentIdFullQueryError = ErrorType<unknown>


export function useGetPlanAssignmentIdFull<TData = Awaited<ReturnType<typeof getPlanAssignmentIdFull>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetPlanAssignmentIdFullParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdFull>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanAssignmentIdFull>>,
          TError,
          Awaited<ReturnType<typeof getPlanAssignmentIdFull>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanAssignmentIdFull<TData = Awaited<ReturnType<typeof getPlanAssignmentIdFull>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetPlanAssignmentIdFullParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdFull>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanAssignmentIdFull>>,
          TError,
          Awaited<ReturnType<typeof getPlanAssignmentIdFull>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanAssignmentIdFull<TData = Awaited<ReturnType<typeof getPlanAssignmentIdFull>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetPlanAssignmentIdFullParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdFull>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPlanAssignmentIdFull<TData = Awaited<ReturnType<typeof getPlanAssignmentIdFull>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetPlanAssignmentIdFullParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdFull>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlanAssignmentIdFullQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlanAssignmentIdOverview = (
    id: number,
    params?: GetPlanAssignmentIdOverviewParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesPlanOverviewResponse>(
      {url: `/plan-assignment/${id}/overview`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPlanAssignmentIdOverviewQueryKey = (id: number,
    params?: GetPlanAssignmentIdOverviewParams,) => {
    return [
    `/plan-assignment/${id}/overview`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPlanAssignmentIdOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>, TError = ErrorType<unknown>>(id: number,
    params?: GetPlanAssignmentIdOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanAssignmentIdOverviewQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>> = ({ signal }) => getPlanAssignmentIdOverview(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlanAssignmentIdOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>>
export type GetPlanAssignmentIdOverviewQueryError = ErrorType<unknown>


export function useGetPlanAssignmentIdOverview<TData = Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetPlanAssignmentIdOverviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>,
          TError,
          Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanAssignmentIdOverview<TData = Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetPlanAssignmentIdOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>,
          TError,
          Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlanAssignmentIdOverview<TData = Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetPlanAssignmentIdOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPlanAssignmentIdOverview<TData = Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetPlanAssignmentIdOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlanAssignmentIdOverview>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlanAssignmentIdOverviewQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postPlanAssignmentIdPause = (
    id: number,
    params?: PostPlanAssignmentIdPauseParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesPlanAssignmentFullResponse>(
      {url: `/plan-assignment/${id}/pause`, method: 'POST',
        params, signal
    },
      options);
    }




export const getPostPlanAssignmentIdPauseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdPause>>, TError,{id: number;params?: PostPlanAssignmentIdPauseParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdPause>>, TError,{id: number;params?: PostPlanAssignmentIdPauseParams}, TContext> => {

const mutationKey = ['postPlanAssignmentIdPause'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPlanAssignmentIdPause>>, {id: number;params?: PostPlanAssignmentIdPauseParams}> = (props) => {
          const {id,params} = props ?? {};

          return  postPlanAssignmentIdPause(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPlanAssignmentIdPauseMutationResult = NonNullable<Awaited<ReturnType<typeof postPlanAssignmentIdPause>>>

    export type PostPlanAssignmentIdPauseMutationError = ErrorType<unknown>

    export const usePostPlanAssignmentIdPause = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdPause>>, TError,{id: number;params?: PostPlanAssignmentIdPauseParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPlanAssignmentIdPause>>,
        TError,
        {id: number;params?: PostPlanAssignmentIdPauseParams},
        TContext
      > => {
      return useMutation(getPostPlanAssignmentIdPauseMutationOptions(options), queryClient);
    }
    export const postPlanAssignmentIdResume = (
    id: number,
    params?: PostPlanAssignmentIdResumeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesPlanAssignmentFullResponse>(
      {url: `/plan-assignment/${id}/resume`, method: 'POST',
        params, signal
    },
      options);
    }




export const getPostPlanAssignmentIdResumeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdResume>>, TError,{id: number;params?: PostPlanAssignmentIdResumeParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdResume>>, TError,{id: number;params?: PostPlanAssignmentIdResumeParams}, TContext> => {

const mutationKey = ['postPlanAssignmentIdResume'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPlanAssignmentIdResume>>, {id: number;params?: PostPlanAssignmentIdResumeParams}> = (props) => {
          const {id,params} = props ?? {};

          return  postPlanAssignmentIdResume(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPlanAssignmentIdResumeMutationResult = NonNullable<Awaited<ReturnType<typeof postPlanAssignmentIdResume>>>

    export type PostPlanAssignmentIdResumeMutationError = ErrorType<unknown>

    export const usePostPlanAssignmentIdResume = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdResume>>, TError,{id: number;params?: PostPlanAssignmentIdResumeParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPlanAssignmentIdResume>>,
        TError,
        {id: number;params?: PostPlanAssignmentIdResumeParams},
        TContext
      > => {
      return useMutation(getPostPlanAssignmentIdResumeMutationOptions(options), queryClient);
    }
    export const postPlanAssignmentIdShiftRemaining = (
    id: number,
    trainWithMeModulesTrainingDtosRequestsShiftRemainingRequest?: BodyType<TrainWithMeModulesTrainingDtosRequestsShiftRemainingRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesShiftRemainingResponse>(
      {url: `/plan-assignment/${id}/shift-remaining`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesTrainingDtosRequestsShiftRemainingRequest, signal
    },
      options);
    }




export const getPostPlanAssignmentIdShiftRemainingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdShiftRemaining>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsShiftRemainingRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdShiftRemaining>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsShiftRemainingRequest>}, TContext> => {

const mutationKey = ['postPlanAssignmentIdShiftRemaining'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPlanAssignmentIdShiftRemaining>>, {id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsShiftRemainingRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  postPlanAssignmentIdShiftRemaining(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPlanAssignmentIdShiftRemainingMutationResult = NonNullable<Awaited<ReturnType<typeof postPlanAssignmentIdShiftRemaining>>>
    export type PostPlanAssignmentIdShiftRemainingMutationBody = BodyType<TrainWithMeModulesTrainingDtosRequestsShiftRemainingRequest> | undefined
    export type PostPlanAssignmentIdShiftRemainingMutationError = ErrorType<unknown>

    export const usePostPlanAssignmentIdShiftRemaining = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPlanAssignmentIdShiftRemaining>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsShiftRemainingRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPlanAssignmentIdShiftRemaining>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsShiftRemainingRequest>},
        TContext
      > => {
      return useMutation(getPostPlanAssignmentIdShiftRemainingMutationOptions(options), queryClient);
    }
